import { safe_get } from "../../../../../report-visuals";
import { zeroPad } from "../../../../../helpers";
import type {
    FlexiStoreData_Abridged,
    FlexiStoreTemplate_Abridged,
} from "../../../../../stores/fs/fst";

export function fstTemplateLabel(t: FlexiStoreTemplate_Abridged) {
    return String(safe_get(t.summary, "name", t.key) || t.key);
}

export function fsdAcLabel(f: FlexiStoreData_Abridged) {
    const ac = safe_get(f.summary, "acno", "");
    const nm = safe_get(f.summary, "acname", "");
    const acStr = ac !== "" && ac != null ? zeroPad(parseInt(String(ac), 10), 3) : "";
    return acStr ? `AC ${acStr} — ${nm || f.key}` : (nm as string) || f.key;
}
